export const EMPTY_VALUE = '-'
export const SHADOW_AI_LOOKBACK_DAYS = 30
export const RECOMMENDATIONS_ANCHOR = 'recommendations'
export const AI_RISK_REPORT_EXPORT_ERROR_TYPE = 'AI_RISK_REPORT_EXPORT'
export const AI_RISK_REPORT_PDF_CHUNK_ATTRIBUTE = 'data-ai-risk-report-pdf-chunk'
export const AI_RISK_REPORT_PDF_CHUNK_VALUE = 'true'
export const AI_RISK_REPORT_PDF_CHUNK_SELECTOR = `[${AI_RISK_REPORT_PDF_CHUNK_ATTRIBUTE}="${AI_RISK_REPORT_PDF_CHUNK_VALUE}"]`
export const AI_RISK_REPORT_PDF_CHUNK_ATTRIBUTES = {
  [AI_RISK_REPORT_PDF_CHUNK_ATTRIBUTE]: AI_RISK_REPORT_PDF_CHUNK_VALUE,
}
export const AI_RISK_REPORT_PDF_KEEP_WITH_NEXT_ATTRIBUTE = 'data-ai-risk-report-pdf-keep-with-next'
export const AI_RISK_REPORT_PDF_KEEP_WITH_NEXT_VALUE = 'true'
export const AI_RISK_REPORT_PDF_KEEP_WITH_NEXT_SELECTOR = `[${AI_RISK_REPORT_PDF_KEEP_WITH_NEXT_ATTRIBUTE}="${AI_RISK_REPORT_PDF_KEEP_WITH_NEXT_VALUE}"]`
export const AI_RISK_REPORT_PDF_KEEP_WITH_NEXT_ATTRIBUTES = {
  [AI_RISK_REPORT_PDF_KEEP_WITH_NEXT_ATTRIBUTE]: AI_RISK_REPORT_PDF_KEEP_WITH_NEXT_VALUE,
}
export const AI_RISK_REPORT_PDF_KEEP_CHUNK_WITH_NEXT_ATTRIBUTES = {
  ...AI_RISK_REPORT_PDF_CHUNK_ATTRIBUTES,
  ...AI_RISK_REPORT_PDF_KEEP_WITH_NEXT_ATTRIBUTES,
}
export const AI_RISK_REPORT_PDF_PAGE_BREAK_PROTECTED_ATTRIBUTE = 'data-ai-risk-report-pdf-page-break-protected'
export const AI_RISK_REPORT_PDF_PAGE_BREAK_PROTECTED_VALUE = 'true'
export const AI_RISK_REPORT_PDF_PAGE_BREAK_PROTECTED_SELECTOR = `[${AI_RISK_REPORT_PDF_PAGE_BREAK_PROTECTED_ATTRIBUTE}="${AI_RISK_REPORT_PDF_PAGE_BREAK_PROTECTED_VALUE}"]`
export const AI_RISK_REPORT_PDF_PAGE_BREAK_PROTECTED_ATTRIBUTES = {
  [AI_RISK_REPORT_PDF_PAGE_BREAK_PROTECTED_ATTRIBUTE]: AI_RISK_REPORT_PDF_PAGE_BREAK_PROTECTED_VALUE,
}

export const TONE = {
  OK: 'ok',
  WARN: 'warn',
  DANGER: 'danger',
  NEUTRAL: 'neutral',
  INFO: 'info',
}

export const DATA_AVAILABILITY_REASON = {
  LICENSE_REQUIRED: 'reason.license_required',
  PERMISSION_REQUIRED: 'reason.permission_required',
  DISCOVER_NOT_COLLECTING: 'reason.discover_not_collecting',
  DISCOVER_QUERY_FAILED: 'reason.discover_query_failed',
}

export const COPILOT_ELIGIBILITY = {
  WITH_ADDON: 'eligible_with_addon',
  WITHOUT_ADDON: 'eligible_without_addon',
  NOT_ELIGIBLE: 'not_eligible',
}

export const STATUS_BADGE_VARIANT_BY_TONE = {
  [TONE.OK]: 'success',
  [TONE.WARN]: 'warning',
  [TONE.DANGER]: 'danger',
  [TONE.INFO]: 'info',
  [TONE.NEUTRAL]: 'secondary',
}

export const BAND_LABEL_ID_BY_TONE = {
  [TONE.OK]: 'AI_RISK_REPORT.BAND.STRONG',
  [TONE.WARN]: 'AI_RISK_REPORT.BAND.MODERATE',
  [TONE.DANGER]: 'AI_RISK_REPORT.BAND.GAPS',
  [TONE.NEUTRAL]: 'AI_RISK_REPORT.BAND.NOT_ASSESSED',
}

export const DATA_KEYS = {
  APP_REGISTRATIONS: 'app_registration',
  ENTERPRISE_APPS: 'enterprise_apps',
  GROUPS: 'groups',
  MANAGED_DEVICES: 'managed_devices',
  RESTRICTED_SHAREPOINT_SEARCH: 'restricted_sharepoint_search',
  EXTERNAL_CONNECTIONS: 'external_connections',
  COPILOT_STUDIO_AGENTS: 'copilot_studio_agents',
  DISCOVERED_AI_APPS: 'discovered_ai_apps',
  DISCOVERED_AI_APP_USERS: 'discovered_ai_app_users',
}

// Language-free codes the backend emits for discovered AI apps (Shadow AI table).
export const SANCTIONED_STATUS = {
  SANCTIONED: 'sanctioned',
  UNSANCTIONED: 'unsanctioned',
  PENDING: 'pending',
  UNKNOWN: 'unknown',
}

export const RISK_LEVEL = { UNKNOWN: 'unknown', LOW: 'low', MEDIUM: 'medium', HIGH: 'high' }

// Why a subsection has no score, surfaced as a tooltip on the greyed-out score. Mirrors the backend
// dataAvailability reason codes; coming-soon is a frontend registry flag with the same code.
export const GAP_REASONS = {
  COMING_SOON: 'reason.coming_soon',
  LICENSE_REQUIRED: 'reason.license_required',
  NOT_ASSESSED: 'reason.existing_data_unavailable',
}

export const GAP_REASON_MESSAGE_IDS = {
  [GAP_REASONS.COMING_SOON]: 'AI_RISK_REPORT.GAP.COMING_SOON',
  [GAP_REASONS.LICENSE_REQUIRED]: 'AI_RISK_REPORT.GAP.LICENSE_REQUIRED',
  [GAP_REASONS.NOT_ASSESSED]: 'AI_RISK_REPORT.GAP.NOT_ASSESSED',
}

// Display labels for the backend `requiredLicense` codes (DATA_KEY_REQUIRED_LICENSE), so a
// license-gated subsection's tooltip can name the license it needs.
export const LICENSE_LABEL_MESSAGE_IDS = {
  'license.entra_id_p1': 'AI_RISK_REPORT.LICENSE.ENTRA_ID_P1',
  'license.entra_id_p2': 'AI_RISK_REPORT.LICENSE.ENTRA_ID_P2',
  'license.purview_p1': 'AI_RISK_REPORT.LICENSE.SENSITIVITY_LABELING',
  'license.purview_dlp': 'AI_RISK_REPORT.LICENSE.PURVIEW_DLP',
  'license.intune': 'AI_RISK_REPORT.LICENSE.INTUNE',
  'license.sharepoint_advanced_management': 'AI_RISK_REPORT.LICENSE.SHAREPOINT_ADVANCED_MANAGEMENT',
  'license.augmentt_discover': 'AI_RISK_REPORT.LICENSE.AUGMENTT_DISCOVER',
}

export const PRODUCTIVITY_HOURS_PER_USER_PER_WEEK = 2.4
